/**
 * Hong Kong / Çin hisse verisi.
 *
 * Eskiden var olmayan /api/hk uçlarına gidiyordu; artık backend'in gerçek piyasa
 * uçlarını kullanan ortak adaptör üzerinden çalışır.
 */
import { fetchAsiaQuotes, fetchChartSeries, fetchPeriodChanges } from '@/services/marketAdapter'
import type { AsiaQuote, ChartPoint, PeriodChange } from '@/services/marketAdapter'

export type { AsiaQuote, ChartPoint, PeriodChange }

export const fetchHkQuotes = (symbols: string[]): Promise<Record<string, AsiaQuote>> =>
  fetchAsiaQuotes(symbols)

export const fetchHkChartData = (symbol: string, period: string): Promise<ChartPoint[]> =>
  fetchChartSeries(symbol, period)

export const fetchHkPeriodChanges = (symbols: string[]): Promise<Record<string, PeriodChange>> =>
  fetchPeriodChanges(symbols)
